<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/services">Services</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                 Lifecycle Management
              </li>
            </ol>
          </nav>

          <div class="row">
            <div class="col-lg-8">
              <h2 class="title">Lifecycle Management</h2>
              <p class="lead">
               One of the challenges Experienced in IT businesses is cost. Keeping an eye on the organizations spending is key to maximizing available resources which is necessary not to risk overspending, which is easier said than done. There’s a wealth of solutions and solution providers that address certain problems but not the entire asset lifecycle. Organizations are looking for a one-stop-shop solution to solve their problems.
              </p>
              <p class="lead">
            However, we offer you automation, simplicity and intelligence while tracking assets. We would take the stress out of your IT infrastructure through our asset management, life cycle automation, visibility and compliance solutions with our technologies giving unique features for IT business like:
              </p>

              <p class="lead">
               
              </p>

              <p class="lead">
              
              </p>

              <H3>Inventory management</H3>
              <p class="lead">
                Tracking assets and obtaining details stress-free associated with it.
              </p>

              <H3>Telemetry</H3>
              <p class="lead">
                Communicating new, current and recommended software to displace existing ones.
              </p>



              <H3>Customized reports</H3>
              <p class="lead">
                Creating reports that are of great value to the organization's success assisting in making decision taking effective.
              </p>


              <H3>Explorable interface</H3>
              <p class="lead">
                Offers simplicity and easy navigation in search of assets.
              </p>



            </div>

            <div class="col-lg-4">
              <ServicesSideNav></ServicesSideNav>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import ServicesSideNav from "./ServicesSideNav";
export default {
  name: "cloud overview",
  components: {
    ServicesSideNav,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
